<div class="bg-m0 flex-grow select-none flex-col overflow-y-auto p-9">
  <div
    data-cy="editGivenDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Edit Given</div
  >

  <form
    class="flex w-[700px] flex-col"
    [formGroup]="editGivenForm"
    (ngSubmit)="edit()"
  >
    <div class="mt-9 flex flex-row items-center text-base">
      <div class="w-[120px] flex-shrink-0 font-semibold">Name</div>
      <div class="ml-2 break-all">{{ dataItem.given.givenId }}</div>
    </div>

    <div class="mt-8 flex flex-row items-center text-base">
      <div class="w-[120px] flex-shrink-0 font-semibold">Type</div>
      <div class="ml-2"
        >{{ dataItem.given.type
        }}{{ dataItem.given.isMultiple ? ' [ ]' : '' }}</div
      >
    </div>

    <div class="mt-6 flex min-h-[220px] flex-row items-start">
      <div class="mt-3 w-[120px] flex-shrink-0 text-base font-semibold">
        {{ dataItem.given.isMultiple ? 'Values' : 'Value' }}
      </div>

      <div class="flex w-[400px] flex-col">
        <input
          *ngIf="!dataItem.given.isMultiple"
          autocomplete="off"
          spellcheck="false"
          data-cy="editGivenDialogValuesInput"
          class="form-input border-s3 focus:border-m600 rounded"
          [ngClass]="{
            'border-r600':
              editGivenForm.controls['values'].invalid &&
              editGivenForm.controls['values'].touched
          }"
          formControlName="values"
          placeholder="Value"
        />

        <textarea
          *ngIf="dataItem.given.isMultiple"
          autocomplete="off"
          spellcheck="false"
          data-cy="editGivenDialogValuesInput"
          class="form-textarea border-s3 focus:border-m600 h-48 resize-none rounded"
          [ngClass]="{
            'border-r600':
              editGivenForm.controls['values'].invalid &&
              editGivenForm.controls['values'].touched
          }"
          formControlName="values"
          placeholder="Values, one per line"
        ></textarea>
        <m-validation
          [control]="editGivenForm.controls['values']"
        ></m-validation>
      </div>
    </div>

    <div class="mt-6">
      <button
        data-cy="editGivenDialogSaveButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Save</button
      >

      <button
        data-cy="editGivenDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
